export const figure29 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'bar',
        height: '600px',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
  
      colors: ['#ed7d31', '#5b9bd5'],
  
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
  
      exporting: {
        enabled: false
      },

      xAxis: [{
        categories: ["Monde", "Asie de l’Est et du Sud-Est", "Asie centrale et du Sud", "Afrique du Nord et Asie de l’Ouest", "Europe et Amérique du Nord", "Australie et Nouvelle-Zélande", "Amérique latine et Caraïbes", "Afrique subsaharienne", "Océanie, hors Australie et Nouvelle-Zélande"],
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          }
        },
      }],
      yAxis: [{
        style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          },
        max: 1.20,
        min: 0,
        tickInterval: 0.20,
        gridLineWidth: 2,
        title: {
          text: false,
        }
      }],
      tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
          padding: 0
        }
      },
      legend: {
        enabled: false,
      },
  
      series: [{
        name: '2020',
        data: [0.51, 1.08, 0.34, 0.32, 0.51, 0.25, 0.22, 0.12, 0.11],
      },
      {
        name: '2015',
        data: [0.50, 0.98, 0.37, 0.31, 0.40, 0.23, 0.35, 0.14, 0.12]
      }
    ]
}